'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _html2pdf = require('html2pdf.js');

var _html2pdf2 = _interopRequireDefault(_html2pdf);

var _dataUriToBlob = require('../../libs/dataUriToBlob');

var _dataUriToBlob2 = _interopRequireDefault(_dataUriToBlob);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Libs


var ToPDF = function (_Component) {
  _inherits(ToPDF, _Component);

  function ToPDF() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToPDF);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToPDF.__proto__ || Object.getPrototypeOf(ToPDF)).call.apply(_ref, [this].concat(args))), _this), _this.onRef = function (dom) {
      return _this.props.onOptions({
        convert: _this.convert(dom)
      });
    }, _this.convert = function (dom) {
      return function () {
        return new Promise(function (resolve, reject) {
          var _html2pdf$set$from$to;

          var _this$props = _this.props,
              output = _this$props.output,
              filename = _this$props.filename,
              options = _this$props.options,
              quality = _this$props.quality;
          var outputProps = output === 'save' ? [output, filename] : [output];

          (_html2pdf$set$from$to = (0, _html2pdf2.default)().set(_extends({
            image: {
              type: 'jpeg',
              quality: quality
            },
            html2canvas: {
              logging: false,
              useCORS: true
            },
            pagebreak: {
              mode: ['avoid-all', 'css']
            }
          }, options)).from(dom).toPdf()).output.apply(_html2pdf$set$from$to, outputProps).then(function (pdf) {
            var file = output === 'datauristring' ? (0, _dataUriToBlob2.default)(pdf) : null;
            resolve(file);
          }).catch(function (err) {
            reject(err);
          });
        });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToPDF, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      return _react2.default.createElement('div', {
        ref: this.onRef
      }, children);
    }
  }]);

  return ToPDF;
}(_react.Component);

ToPDF.propTypes = {
  children: _propTypes2.default.node.isRequired,
  options: _propTypes2.default.object,
  output: _propTypes2.default.oneOf(['datauristring', 'dataurlnewwindow', 'datauri', 'save']),
  filename: _propTypes2.default.string,
  quality: _propTypes2.default.number,
  onOptions: _propTypes2.default.func.isRequired
};
ToPDF.defaultProps = {
  options: {},
  output: 'datauristring',
  quality: 1,
  filename: 'file.pdf'
};
exports.default = ToPDF;